/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonDailyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyTrxCount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/transaction/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTokenInfoMView(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/token/mview/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateTokenMetadata(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/token/metadata/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenHolderCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/token/holder/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setIbcRelayerMView(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/ibc/relayer/mview',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setIbcChannelMView(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/ibc/channel/mview',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setIbcChannelDailyChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/ibc/channel/daily/chart',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateAllFinalityProvider(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/finality/provider',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyBtcStakingChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/schedule/daily/btc/staking/amount',
            query: {
                'targetDate': targetDate,
            },
        });
    }

}
